package ai.beakman.undercover.i18n

/** Textos de la interfaz en español (es). Español neutro/latino, tono de juego de fiesta. */
object StringsEs : Strings {
    // --- App / branding / splash ---
    override val appTitle = "UNDERCOVER"
    override val webBrandTitle = "EL INFILTRADO"
    override val webBrandTagline = "¿Quién eres?"
    override val splashContentDescription = "Undercover"
    override val webHomeHeroAlt = "El Infiltrado"

    // --- Home: escolha de modo ---
    override val homeHowToPlay = "¿Cómo van a jugar?"
    override val modeLocalTitle = "Local"
    override val modeLocalSubtitle = "Pásense un celular entre amigos en la misma sala."
    override val modeOnlineTitle = "En línea"
    override val modeOnlineSubtitleShared = "Cada uno en su celular, con un código."
    override val modeOnlineSubtitleWeb = "Cada uno en su dispositivo, con un código."
    override val onlineSoonTitle = "Modo en línea"
    override val onlineSoonBody = "Llega en la próxima fase (Firestore ya está listo)."

    // --- Navegação / voltar / sair ---
    override val backVoltar = "Volver"
    override val backTrocarModo = "Cambiar modo"
    override val backArrowVoltar = "← Volver"
    override val backArrowSair = "← Salir"
    override val exitSair = "✕ Salir"

    // --- Setup local: jogadores ---
    override fun playersCount(n: Int) = "Jugadores ($n)"
    override val namesAddHint = "Agrega a todos los que van a jugar en este celular."
    override val namesPlayerPlaceholder = "Nombre del jugador"
    override fun minPlayers(n: Int) = "Mínimo $n jugadores."
    override val continueNext = "Continuar →"

    // --- Setup: tema ---
    override val chooseTheme = "Elige un tema"
    override val themeWillBeDrawn = "Se sorteará una palabra de ese tema."

    // --- Setup: infiltrados ---
    override val infiltratorsTitle = "Infiltrados"
    override val infiltratorSingular = "infiltrado"
    override val infiltratorPlural = "infiltrados"
    override val needTwoCommons = "Se necesitan al menos 2 jugadores comunes."

    // --- Setup: tempo / iniciar ---
    override val discussionTimeTitle = "Tiempo de discusión"
    override val startMatch = "Iniciar partida"

    // --- Reveal ---
    override fun revealPlayerXofN(i: Int, n: Int) = "Jugador $i de $n"
    override val youAre = "ERES"
    override val infiltrator = "INFILTRADO"
    override val hintLabel = "Pista:"
    override val yourAccompliceSingular = "Tu cómplice:"
    override val yourAccomplicesPlural = "Tus cómplices:"
    override val yourWord = "TU PALABRA"
    override fun themeWithEmoji(emoji: String, name: String) = "Tema: $emoji $name"
    override val revealDragHint = "Desliza hacia arriba y mantén\npresionado para ver tu carta"
    override val revealHoldHint = "Mantén presionado para ver tu carta"
    override val nextPlayer = "Siguiente jugador →"
    override val startDiscussion = "Empezar discusión →"

    // --- Discussão / timer ---
    override val discussionPrompt = "Háganse preguntas entre ustedes. ¿Quién es el infiltrado?"
    override val goToVote = "Ir a la votación"

    // --- Votação ---
    override val voteTitle = "Votación"
    override fun voteTurnOf(name: String) = "Turno de $name"
    override fun voteChooseSuspectsLocal(n: Int) = "Elige $n sospechoso(s) (no puedes votarte a ti)"
    override val voteWhoIsInfiltrator = "¿Quién es el infiltrado?"
    override fun voteChoosePlayersOnline(n: Int) = "Elige $n jugador(es)"
    override val voteRegisteredWaitingShared = "Voto registrado. Esperando a los demás."
    override fun voteRegisteredWaitingWeb(voted: Int, total: Int) =
        "Voto registrado. Esperando a los demás... ($voted/$total votaron)"
    override fun voteSelectedOfNParen(selected: Int, n: Int) = "$selected/$n seleccionado(s)"
    override fun voteSelectedOfNSuffix(selected: Int, n: Int) = "$selected/$n seleccionado(s)"
    override val voteConfirm = "Confirmar voto"
    override val voteSending = "Enviando..."
    override val voteConfirmArrow = "Confirmar voto →"
    override val voteConfirmAndResult = "Confirmar y ver resultado"
    override val voteStatusVoted = "votó"
    override val voteStatusVoting = "votando..."
    override val showResult = "Mostrar resultado"
    override fun showResultPartial(voted: Int, total: Int) = "Mostrar resultado ($voted/$total votaron)"
    override val seeResult = "Ver resultado"
    override fun seeResultPartial(voted: Int, total: Int) = "Ver resultado ($voted/$total votaron)"

    // --- Resultado ---
    override val resultPlayersWonEmoji = "🎉"
    override val resultInfiltratorWonEmoji = "🕵️"
    override val resultPlayersWon = "¡Ganaron los jugadores!"
    override val resultInfiltratorWon = "¡Ganó el infiltrado!"
    override val resultCaughtAll = "Atraparon al/los infiltrado(s)."
    override val resultCaughtSome = "Atraparon a uno, pero no a todos."
    override val resultCaughtNone = "El infiltrado engañó a todos."
    override val resultWordWas = "La palabra era"
    override val resultInfiltratorSingular = "Infiltrado"
    override val resultInfiltratorsPlural = "Infiltrados"
    override val resultVotesLabel = "Votos"
    override fun votesCountLocal(count: Int) = "$count voto(s)"
    override fun votesCountOnline(count: Int) = "$count voto(s)"
    override val playAgain = "Jugar de nuevo"
    override val configureNewGame = "Configurar nuevo juego"

    // --- Online: menu / criar / entrar ---
    override val onlineModeLabel = "Modo en línea"
    override val onlineMenuSubtitle = "Cada uno en su celular, en la misma sala."
    override val createRoomCardTitle = "Crear sala"
    override val createRoomCardSubtitle = "Tú eres el anfitrión"
    override val joinRoomCardTitle = "Entrar con código"
    override val joinRoomCardSubtitle = "Únete a una sala"
    override val createRoomDesc = "Elige tu nombre y el tema de la partida."
    override val yourNamePlaceholder = "Tu nombre"
    override val themeLabel = "Tema"
    override val createRoomCreating = "Creando..."
    override val createRoomError =
        "No se pudo crear la sala. Revisa tu internet e inténtalo de nuevo."
    override val joinRoomDesc = "Pídele el código de 5 letras al anfitrión."
    override val codePlaceholder = "CÓDIGO"
    override val joinEnter = "Entrar"
    override val joinEntering = "Entrando..."
    override fun joinRoomNotFound(code: String) =
        "Sala $code no encontrada. Confirma el código con el anfitrión."
    override val joinRoomError =
        "No se pudo entrar a la sala. Revisa tu internet e inténtalo de nuevo."

    // --- Online: erros / estado de sala ---
    override val actionSyncError =
        "No se pudo sincronizar con la sala. Revisa tu internet e inténtalo de nuevo."
    override val roomClosed = "La sala fue cerrada."
    override val loadingRoom = "Cargando sala..."
    override val roomLabel = "Sala"
    override val roomCodeLabel = "Código de la sala"

    // --- Online: convite / cópia ---
    override val inviteButton = "📤 Invitar"
    override val inviteCopiedConfirm = "✓ ¡Invitación copiada!"
    override val copyCode = "Copiar código"
    override val copiedShared = "¡Copiado!"
    override val copiedWeb = "✓ ¡Copiado!"
    override fun inviteMessage(code: String, baseUrl: String) =
        "¡Ven a jugar El Infiltrado conmigo! 🕵️\nEntra a la sala: $baseUrl/sala/$code\nCódigo de la sala: $code"

    // --- Online: lobby ---
    override val timeLabel = "Tiempo"
    override val hostBadgeShared = "ANFITRIÓN"
    override val hostBadgeWeb = "⭐ ANFITRIÓN"
    override val playerYouSuffix = "(tú)"
    override val lobbyStartWeb = "Empezar"
    override val lobbyStartingWeb = "Empezando..."
    override val waitingPlayersMin3 = "Esperando jugadores (mín. 3)"
    override val waitingHostStartShared = "Esperando a que el anfitrión inicie la partida..."
    override val waitingHostStartWeb = "Esperando a que el anfitrión empiece..."

    // --- Online: reveal ---
    override fun revealTopBarReady(ready: Int, total: Int) = "Tu carta · $ready/$total listos"
    override val imReady = "Estoy listo"
    override val readyConfirmed = "✓ Listo"
    override fun waitingNReady(remaining: Int) = "Esperando a $remaining..."
    override val revealSecretCardCover = "CARTA SECRETA"
    override val revealHoldToPeek = "Mantén presionado para espiar"
    override val revealOnlyYouCanSee = "Solo tú puedes verla. Suelta para ocultar."

    // --- Online: resultado ---
    override val resultLeaveRoom = "Salir de la sala"
    override val resultPreparing = "Preparando..."
}
